import '../../tailwind.css'
import React, {useState} from "react";
import {useNavigate} from "react-router";
import PopupProduct from "../pop up not used/pop-product";
import {ToastContainer} from "react-toastify";

const callouts = [
  {
    name: 'Desk and Office',
    description: 'Work from home accessories',
    imageSrc: 'https://tailwindui.com/img/ecommerce-images/home-page-02-edition-01.jpg',
    imageAlt: 'Desk with leather desk pad, walnut desk organizer, wireless keyboard and mouse, and porcelain mug.',
    href: '#',
  },
  {
    name: 'Self-Improvement',
    description: 'Journals and note-taking',
    imageSrc: 'https://tailwindui.com/img/ecommerce-images/home-page-02-edition-02.jpg',
    imageAlt: 'Wood table with porcelain mug, leather journal, brass pen, leather key ring, and a houseplant.',
    href: '#',
  },
  {
    name: 'Travel',
    description: 'Daily commute essentials',
    imageSrc: 'https://tailwindui.com/img/ecommerce-images/home-page-02-edition-03.jpg',
    imageAlt: 'Collection of four insulated travel bottles on wooden shelf.',
    href: '#',
  },
     {
    name: 'Deskr and Office',
    description: 'Work from home accessories',
    imageSrc: 'https://tailwindui.com/img/ecommerce-images/home-page-02-edition-01.jpg',
    imageAlt: 'Desk with leather desk pad, walnut desk organizer, wireless keyboard and mouse, and porcelain mug.',
    href: '#',
  },
  {
    name: 'Selfr-Improvement',
    description: 'Journals and note-taking',
    imageSrc: 'https://tailwindui.com/img/ecommerce-images/home-page-02-edition-02.jpg',
    imageAlt: 'Wood table with porcelain mug, leather journal, brass pen, leather key ring, and a houseplant.',
    href: '#',
  },
  {
    name: 'Travrel',
    description: 'Daily commute essentials',
    imageSrc: 'https://tailwindui.com/img/ecommerce-images/home-page-02-edition-03.jpg',
    imageAlt: 'Collection of four insulated travel bottles on wooden shelf.',
    href: '#',
  },



    {
    name: 'Desk jand Office',
    description: 'Work from home accessories',
    imageSrc: 'https://tailwindui.com/img/ecommerce-images/home-page-02-edition-01.jpg',
    imageAlt: 'Desk with leather desk pad, walnut desk organizer, wireless keyboard and mouse, and porcelain mug.',
    href: '#',
  },
  {
    name: 'Self-Improjjvement',
    description: 'Journals and note-taking',
    imageSrc: 'https://tailwindui.com/img/ecommerce-images/home-page-02-edition-02.jpg',
    imageAlt: 'Wood table with porcelain mug, leather journal, brass pen, leather key ring, and a houseplant.',
    href: '#',
  },
  {
    name: 'Travjjel',
    description: 'Daily commute essentials',
    imageSrc: 'https://tailwindui.com/img/ecommerce-images/home-page-02-edition-03.jpg',
    imageAlt: 'Collection of four insulated travel bottles on wooden shelf.',
    href: '#',
  },
     {
    name: 'Deskr and Olfice',
    description: 'Work from home accessories',
    imageSrc: 'https://tailwindui.com/img/ecommerce-images/home-page-02-edition-01.jpg',
    imageAlt: 'Desk with leather desk pad, walnut desk organizer, wireless keyboard and mouse, and porcelain mug.',
    href: '#',
  },
  {
    name: 'Selfr-llImprovement',
    description: 'Journals and note-taking',
    imageSrc: 'https://tailwindui.com/img/ecommerce-images/home-page-02-edition-02.jpg',
    imageAlt: 'Wood table with porcelain mug, leather journal, brass pen, leather key ring, and a houseplant.',
    href: '#',
  },
  {
    name: 'Trahkvrel',
    description: 'Daily commute essentials',
    imageSrc: 'https://tailwindui.com/img/ecommerce-images/home-page-02-edition-03.jpg',
    imageAlt: 'Collection of four insulated travel bottles on wooden shelf.',
    href: '#',
  }
]


export default function View2({ callouts }) {
  const navigate = useNavigate()



const [expandedDescriptions, setExpandedDescriptions] = useState({});

  const toggleDescription = (name) => {
    setExpandedDescriptions((prevState) => ({
      ...prevState,
      [name]: !prevState[name],
    }));
  };




   const categories = [
      'Tafuta hapa...',
  'Watch',
  'Shoes',
  'Mask',
  '7',
  'Books',
];
  const [query, setQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("Tafuta hapa...");
  const [filteredProducts, setFilteredProducts] = useState(callouts);
   const [search, showSearch] = useState(false)


  const handleInputChange = (event) => {
    setQuery(event.target.value);
  };

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
  };

 const handleSearch = () => {
  console.log("Search Button Clicked");
  console.log("Selected Category:", selectedCategory);
  console.log("Query:", query);
 /* alert('Sorry ninaendelea kufanyia maboresho eneo hili keep expore and order more product')*/

  // Log the product data for debugging
  console.log("Product Images:", callouts);

  // Perform the search based on the selectedCategory and query
  let filtered = callouts;

  if (selectedCategory !== "Tafuta hapa...") {
    console.log("Applying Category Filter");
    filtered = filtered.filter(
      (product) => product.category === selectedCategory
    );
  }

  if (query.trim() !== "") {
    console.log("Applying Query Filter");
    filtered = filtered.filter((product) =>
      product.name.toLowerCase().includes(query.toLowerCase())
    );
  }

  console.log("Filtered Products:", filtered);

  setFilteredProducts(filtered);
  showSearch(false);
};


  return (
   /*<div className="">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-2xl py-0 sm:lg:max-w-none">
          <div className="mt-2 space-y-12 lg:grid lg:grid-cols-3 lg:gap-x-6 lg:space-y-0">
            {callouts.map((callout) => (
              <div key={callout.name} className="group relative">
                <div className="relative h-80 w-full overflow-hidden rounded-lg bg-white sm:aspect-h-1 sm:aspect-w-2 lg:aspect-h-1 lg:aspect-w-1 group-hover:opacity-75 sm:h-64">
                  <img
                    src={callout.photo}
                    alt={callout.name}
                    className="h-full w-full object-cover object-center"
                  />
                </div>
                <div className="mt-6 text-sm text-gray-500 flex justify-between items-center">
                  <a href={callout.href} className="flex items-center">
                    <span className="absolute inset-0" />
                    <span className="mr-2">{callout.name}</span>
                  </a>
                  <p className="text-base font-semibold">
                    TZS {callout.price}
                  </p>
                </div>
                <div className="featured__title font-semibold text-sm">
                  {expandedDescriptions[callout.name] ||
                  callout.description.length <= 90 ? (
                    callout.description
                  ) : (
                    <>
                      {callout.description.slice(0, 90)}...
                      <span
                        className="text-blue-600 cursor-pointer ml-1"
                        onClick={() => toggleDescription(callout.name)}
                      >
                        (more)
                      </span>
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>*/
     <div className="mt-5">
       <ToastContainer/>
      <div className="mx-auto">{/*className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8"*/}
        <div className="mx-auto  max-w-2xl py-0 sm:lg:max-w-none">
          <div className="mt-2 space-y-12 lg:space-y-12">
            {callouts.map((callout, index) => (
              <div
                key={callout.id}
                className={`relative ${
                  index < callouts.length - 1 ? "mb-4 sm:mb-0" : ""
                }`}
              >
                <div
                  className="overflow-hidden  rounded-lg  sm:aspect-h-1 sm:aspect-w-2 lg:aspect-h-1 lg:aspect-w-1 group-hover:opacity-75 "

                  /*relative  w-full overflow-hidden rounded-lg  sm:aspect-w-2 lg:aspect-h-1 lg:aspect-w-1 lg:group-hover:opacity-75 sm:h-64*/
                  style={{
                    maxWidth: "640px",
                    margin: "0 auto",
                  }}

                 /* bg-white*/
                >
                  <div className="w-full" onClick={()=>{{/*navigate(`/popup?d=${encodeURIComponent(JSON.stringify(callout))}`);*/} PopupProduct.show(callout)}}>
                    <img
                      src={callout.photo}
                      alt={callout.imageAlt}
                      className="w-full h-auto  rounded-lg  bg-white object-cover object-center"
                      style={{
                        borderRadius: '8px', // Match the border radius
                        zIndex: 1,
                         filter: 'brightness(1.1) contrast(1.1) saturate(1.1)'
                      }}
                    />
                  </div>
                  <div className="mt-0 text-sm text-gray-500 flex justify-between items-center">
                    <a href={callout.href} className="flex items-center">
                      <span style={{fontWeight:"bold", textTransform:"capitalize"}} className="mr-2 products__price">{callout.name.split('-')[0]}</span>
                    </a>
                    <p className=" nav__linkT font-semibold">
                      TZS {callout.price}
                    </p>
                  </div>

                  <div className={'text-justify text-gray-500   mt-1 '}>
                   <span style={{fontWeight:"bold", fontSize:'18px'}} className={' products__price'}>Size:</span> <b className={'text-blue-500'}><i>{callout.size}</i></b>
                  </div>

                  <div className="featured__title  lowercase text-gray-500 mt-2 text-justify font-semibold text-sm">
                    {callout.description.length <= 150 || expandedDescriptions[callout.name] ? (
                      callout.description
                    ) : (
                      <>
                        {callout.description.slice(0, 150)}...
                        <span
                          className="text-blue-600 cursor-pointer ml-1"
                          onClick={() => toggleDescription(callout.name)}
                        >
                          {expandedDescriptions[callout.name] ? "(less)" : "(more)"}
                        </span>
                      </>
                    )}

                    {expandedDescriptions[callout.name] && (
                    <span
                      className="text-blue-600 cursor-pointer "
                      onClick={() => toggleDescription(callout.name)}
                    >
                      (show less)
                    </span>
                  )}
                  </div>

                </div>
              </div>
            ))}
          </div>
        </div>
      </div>




        <div onClick={()=>showSearch(true)} data-dial-init className="fixed bx-burst z-90 right-6 bottom-20 group">
          <div id="speed-dial-menu-default" className="flex hidden flex-col items-center mb-4 space-y-2">

          </div>
          <button type="button" data-dial-toggle="speed-dial-menu-default" aria-controls="speed-dial-menu-default"
                  aria-expanded="false"
                  className="flex justify-center items-center w-10 h-10 lg:w-14 lg:h-14 text-white bg-blue-700 rounded-full hover:bg-blue-800 dark:bg-blue-600 dark:hover:bg-blue-700 focus:ring-4 focus:ring-blue-300 focus:outline-none dark:focus:ring-blue-800">
           {/* <svg aria-hidden="true" className="lg:w-8 lg:h-8 w-6 h-6 transition-transform group-hover:rotate-45" fill="none"
                 stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
            </svg>*/}
            <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M21 21l-5.2-5.2M15 9a6 6 0 11-12 0 6 6 0 0112 0z"
                    />
                  </svg>
            <span className="sr-only">Open actions menu</span>
          </button>
        </div>



 {search && (
        <div className="fixed inset-0 flex justify-end items-start bg-gray-800 bg-opacity-50">
          <div className="p-4 bg-blue-100 w-full max-w-screen rounded-md shadow-lg animate-slideInFromTopRight">
            <h2 className="text-center font-bold text-gray-800">Tafuta hapa...</h2>
            <p className="text-center mt-3 font-bold text-red-800">
              *Chagua size unayohitaji*
            </p>

            <div className="mt-5 md:mt-8 w-full flex items-center justify-between">
              <div className="flex items-center w-5/6">
                <select
                  value={selectedCategory}
                  onChange={(e) => handleCategoryChange(e.target.value)}
                  className="text-sm font-bold text-center rounded border-2 border-purple-700 text-gray-600  w-full py-2 pl-5 pr-10 bg-white hover:border-gray-400 focus:outline-none appearance-none"
                >
                  {categories.map((category, index) => (
                    <option key={index} value={category}>
                      {category}
                    </option>
                  ))}
                </select>
              </div>
              <div className="ml-2">
                <button
                  onClick={handleSearch}
                  className="border border-gray-800 text-base font-medium text-gray-800 px-4 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800 bg-gray-800 hover:bg-gray-900 text-white"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M21 21l-5.2-5.2M15 9a6 6 0 11-12 0 6 6 0 0112 0z"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}













    </div>
  );
}